export class DistributionPromoMechanic {
    private id: number
    public get _id(): number {
        return this.id;
    }
    public set _id(value: number) {
        this.id = value;
    }

    private sequence: number;
    public get _sequence(): number {
        return this.sequence;
    }
    public set _sequence(value: number) {
        this.sequence = value;
    }

    private mechanic_period_from_qty: number;
    public get _mechanic_period_from_qty(): number {
        return this.mechanic_period_from_qty;
    }
    public set _mechanic_period_from_qty(value: number) {
        this.mechanic_period_from_qty = value;
    }

    private mechanic_period_to_qty: number;
    public get _mechanic_period_to_qty(): number {
        return this.mechanic_period_to_qty;
    }
    public set _mechanic_period_to_qty(value: number) {
        this.mechanic_period_to_qty = value;
    }

    private mechanic_transaction_count_from_qty: number;
    public get _mechanic_transaction_count_from_qty(): number {
        return this.mechanic_transaction_count_from_qty;
    }
    public set _mechanic_transaction_count_from_qty(value: number) {
        this.mechanic_transaction_count_from_qty = value
    }

    private mechanic_transaction_count_to_qty: number;
    public get _mechanic_transaction_count_to_qty(): number {
        return this.mechanic_transaction_count_to_qty;
    }
    public set _mechanic_transaction_count_to_qty(value: number) {
        this.mechanic_transaction_count_to_qty = value
    }

    private purchase_min: number;
    public get _purchase_min(): number {
        return this.purchase_min;
    }
    public set _purchase_min(value: number) {
        this.purchase_min = value;
    }

    private purchase_max: number;
    public get _purchase_max(): number {
        return this.purchase_max;
    }
    public set _purchase_max(value: number) {
        this.purchase_max = value;
    }

    private discount_value: number;
    public get _discount_value(): number {
        return this.discount_value;
    }
    public set _discount_value(value: number) {
        this.discount_value = value;
    }
}